<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 78.667 78.67"
       :aria-labelledby="iconName"
       role="presentation">
    <title :id="iconName" lang="en">{{iconName}}</title>
    <g :fill="color">
      <path d="M55.182,24.972c-1.219-1.218-3.191-1.217-4.408,0L39.335,36.411L27.9,24.972 c-1.218-1.217-3.19-1.218-4.408,0c-1.217,1.217-1.217,3.19,0,4.408l11.436,11.439L23.492,52.253c-1.217,1.218-1.217,3.19,0,4.408 c0.608,0.608,1.406,0.912,2.204,0.912c0.797,0,1.595-0.304,2.204-0.912l11.435-11.435l11.431,11.434 c0.608,0.609,1.406,0.913,2.204,0.913s1.595-0.304,2.203-0.912c1.218-1.217,1.218-3.19,0.001-4.407L43.742,40.819l11.44-11.44 C56.399,28.163,56.399,26.189,55.182,24.972z"/>
      <path d="M39.34,0C17.648,0,0,17.648,0,39.34C0,61.027,17.648,78.67,39.34,78.67 c21.685,0,39.327-17.644,39.327-39.331C78.667,17.648,61.025,0,39.34,0z M39.34,72.438c-18.255,0-33.106-14.848-33.106-33.098 c0-18.255,14.852-33.106,33.106-33.106c18.249,0,33.094,14.852,33.094,33.106C72.434,57.59,57.588,72.438,39.34,72.438z"/>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      iconName: {
        type: String,
        default: ''
      },
      width: {
        type: [Number, String],
        default: 20
      },
      height: {
        type: [Number, String],
        default: 20
      },
      color: {
        type: String,
        default: 'red'
      }
    }
  }
</script>